import { call, put, takeLatest } from "redux-saga/effects";
import {
  brandAddSuccess,
  brandAddFailure,
  brandEditSuccess,
  brandEditFailure,
  brandDeleteSuccess,
  brandDeleteFailure,
  brandViewSuccess,
  brandViewFailure,
  brandViewAllSuccess,
  brandViewAllFailure,
  brandSearchViewAllSuccess,
  brandSearchViewAllFailure,
  brandViewByAlcoholIdSuccess,
  brandViewByAlcoholIdFailure,
} from "./BrandAction";

import {
  BRAND_ADD_REQUEST,
  BRAND_EDIT_REQUEST,
  BRAND_DELETE_REQUEST,
  BRAND_VIEW_REQUEST,
  BRAND_VIEW_ALL_REQUEST,
  BRAND_SEARCH_REQUEST,
  BRAND_VIEW_BY_ALCOHOL_ID_REQUEST,
} from "./BrandTypes";

import {
  AddBrandEffect,
  EditBrandEffect,
  DeleteBrandEffect,
  ViewBrandEffect,
  ViewAllBrandsEffect,
  ViewAllSearchBrands,
  ViewBrandsByAlcoholIdEffect,
} from "./BrandEffect";

function* addBrandSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(AddBrandEffect, action.payload, config);
    yield put(brandAddSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add brand";
    yield put(brandAddFailure({ errormessage: message, errorFields }));
  }
}

function* editBrandSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const { brandId } = action.payload;
    const { product_id, type_of_alcohol_id, brand_name, flavour, year, status, id } = brandId;
    const formdata = { product_id, type_of_alcohol_id, brand_name, flavour, year, status };
    const response = yield call(EditBrandEffect, id, formdata, config);
    yield put(brandEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to edit brand";
    yield put(
      brandEditFailure({ errormessage: message, errorFields, message })
    );
  }
}

function* viewBrandSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewBrandEffect, action.payload, config);
    yield put(brandViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brand details";
    yield put(brandViewFailure({ errormessage: errorMessage }));
  }
}

function* viewAllBrandsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllBrandsEffect, action.payload, config);
    yield put(brandViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(brandViewAllFailure({ errormessage: errorMessage }));
  }
}

function* viewBrandsByAlcoholIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewBrandsByAlcoholIdEffect,
      action.payload,
      config
    );
    yield put(brandViewByAlcoholIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(brandViewByAlcoholIdFailure({ errormessage: errorMessage }));
  }
}

function* viewAllSearchBrands(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllSearchBrands, action.payload, config);
    yield put(brandSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(brandSearchViewAllFailure({ errormessage: errorMessage }));
  }
}

function* deleteBrandSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(DeleteBrandEffect, action.payload, config);
    yield put(brandDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete brand";
    yield put(brandDeleteFailure({ errormessage: errorMessage }));
  }
}

export function* BrandSaga() {
  yield takeLatest(BRAND_ADD_REQUEST, addBrandSaga);
  yield takeLatest(BRAND_EDIT_REQUEST, editBrandSaga);
  yield takeLatest(BRAND_DELETE_REQUEST, deleteBrandSaga);
  yield takeLatest(BRAND_VIEW_REQUEST, viewBrandSaga);
  yield takeLatest(BRAND_VIEW_ALL_REQUEST, viewAllBrandsSaga);
  yield takeLatest(BRAND_VIEW_BY_ALCOHOL_ID_REQUEST, viewBrandsByAlcoholIdSaga);
  yield takeLatest(BRAND_SEARCH_REQUEST, viewAllSearchBrands);
}
